import AccountLayout from '@/components/feature/AccountLayout';
import { CertificationSection } from './modules';

export default function CertificationPage() {
  return (
    <AccountLayout
      activePath="/certification"
      breadcrumbs={[{ label: '账号中心', href: '/profile' }, { label: '实名认证' }]}
    >
      <CertificationSection />
    </AccountLayout>
  );
}